import { START_LOADING, FINISH_LOADING } from '../types/loading';

let initialState = {
  loading: false,
  pending: 0,
};

export default function reducer(state = initialState, action) {
  const { type } = action;

  switch (type) {
    case START_LOADING:
      state.loading = true;
      state.pending++;
      return {
        ...state,
      };
    case FINISH_LOADING:
      state.loading = false;
      if (state.pending > 0) {
        state.pending--;
      }
      return {
        ...state,
      };
    default:
      return state;
  }
}
